import { filterReturnableItems } from "../lib/returnable-items.lib";
import type { OrderLineItem } from "../types";
import { usePublicOrder } from "./use-public-order";
import { useReturnRequests } from "./use-return-requests";

export function useReturnableItems(
  orderId: string,
  shopSlug: string,
): OrderLineItem[] {
  const { data: order } = usePublicOrder(orderId);
  const { data: returnRequestsData } = useReturnRequests({ orderId, shopSlug });

  const lineItems = order?.lineItems ?? [];
  const returnRequests = returnRequestsData?.returnRequests ?? [];

  return filterReturnableItems(lineItems, returnRequests);
}
